import React, { PureComponent } from 'react';
import { IChartSeries } from 'types';
import Form, { TextField, NumberField, Group } from 'ui/form';
import Button from 'ui/button';
import { ICON_DELETE, ICON_UNDO } from 'icons';
import { Fade } from 'ui/transition';
interface ChartAttributeItemProps {
  item: IChartSeries;
  onChange: (id: string, update: IChartSeries) => void;
}
class ChartAttributeItem extends PureComponent<ChartAttributeItemProps> {
  state = { changes: false };
  handleSubmit = (update: IChartSeries) => {
    this.props.onChange(this.props.item.id, { ...this.props.item, ...update });
    this.setState({ changes: false });
  };

  handleChange = () => this.setState({ changes: true });

  render() {
    const { item } = this.props;
    return (
      <div>
        {item.id && (
          <div className="row">
            <h2 className="flex">Attribute id: {item.id}</h2>
            <Button icon={item.custom ? ICON_DELETE : ICON_UNDO} />
          </div>
        )}
        {!item.id && <h2>Create new attribute</h2>}
        <Form formData={item} noButtons onSubmit={this.handleSubmit} onChange={this.handleChange}>
          <Group columns={2}>
            <TextField name="name" default={item.id} />
            <TextField name="format" label="Value format" />
          </Group>
          <Group columns={2}>
            <NumberField name="scale" label="Scale the number" default={1} precision={10} />
            <NumberField
              min={0}
              max={6}
              name="decimals"
              label="Show number of decimals"
              default={1}
            />
          </Group>
          {item.custom && (
            <div>
              <TextField
                name="merge"
                label="Merge attributes math"
                help="You can do any type of javascript math and just insert the ids as variables"
              />
            </div>
          )}
          <Fade in={this.state.changes}>
            <Button flat="Save" type="submit" raised />
          </Fade>
        </Form>
      </div>
    );
  }
}

export default ChartAttributeItem;
